(function (app) {
	app.saleCategories('sale-category-selected');
})(app);